export const chaosMap = {
    title: 'カオスマップ',
    tooltip:
        'バリューチェーンの要素及び技術クラスタごとにどういうプレイヤーが存在するのかが表示されるので、ユーザーはカオスマップを把握することができます。',
    table: 'クラスタのカオスマップ',

    nace: 'プロセス',
    name: '企業名'
}
